import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const historyColumns: GridColumnConfig[] = [
  {
    title: 'Equipment Service Name',
    field: 'equipmentServiceName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service On',
    field: 'servicedOn',
    filter: 'text',
    searchable: true,
  },
];
